import { type FC } from 'react';

import { CardAddressBlockContainer } from '../../CardAddressBlockContainer';
import { CardSpecialGeoListContainer } from '../../CardSpecialGeoListContainer';
import { GeoLayout } from '../components/GeoLayout';

import { ParentContainer } from './ParentContainer';

export const GeoContainer: FC = () => {
  return (
    <GeoLayout
      address={<CardAddressBlockContainer />}
      parent={<ParentContainer />}
      specialGeo={<CardSpecialGeoListContainer />}
    />
  );
};
